import { MARKER_ANCHOR } from '../utils/markerConstants';
import { createMarkerPopup } from '../utils/markerPopupUtils';
import { createPlanPopup } from '../utils/popupBuilder';
import { selectTourById, setOrders, setSolutionJson, updateOrder } from '../../../../actions';

export function attachHoverEvents(marker, ui, translations, map, ordersRef, dispatch, solution) {
  createMarkerPopup(
    marker,
    map,
    (data) => (data?.isEditing ? MARKER_ANCHOR.EDITING.y : MARKER_ANCHOR.NORMAL.y),
    (data) => createPlanPopup(data, translations, ordersRef.current),
    (popupElement, markerData) => {
      if (!dispatch || !solution) return;
      const select = popupElement.querySelector('.parking-assignment-select');
      if (!select) return;

      // Native title tooltips on <select>/<option> are unreliable across
      // browsers (notably not shown at all on the closed select in Chrome),
      // and a CSS-only tooltip would get clipped by the popup's own
      // overflow:auto/max-height. Render a fixed-position tooltip appended
      // directly to <body> instead, positioned via the select's real
      // screen coordinates, so it always renders on top and uncropped.
      let tooltipEl = null;
      const removeTooltip = () => {
        if (tooltipEl) {
          tooltipEl.remove();
          tooltipEl = null;
        }
      };
      const showTooltip = () => {
        const text = select.title;
        if (!text) return;
        removeTooltip();
        tooltipEl = document.createElement('div');
        tooltipEl.className = 'js-parking-tooltip';
        tooltipEl.textContent = text;
        document.body.appendChild(tooltipEl);
        const rect = select.getBoundingClientRect();
        tooltipEl.style.left = `${rect.left}px`;
        tooltipEl.style.top = `${rect.bottom + 4}px`;
      };
      select.addEventListener('mouseenter', showTooltip);
      select.addEventListener('mouseleave', removeTooltip);
      select.addEventListener('focus', showTooltip);
      select.addEventListener('blur', removeTooltip);

      select.addEventListener('change', (evt) => {
        const newParkingId = evt.target.value || undefined;
        const selectedOption = evt.target.selectedOptions?.[0];
        const selectedText = selectedOption ? selectedOption.textContent : '';
        evt.target.title = selectedText;
        if (tooltipEl) {
          tooltipEl.textContent = selectedText;
        }
        const orderIndex = ordersRef.current.findIndex((o) => o.InternalID === markerData.id);
        if (orderIndex < 0) return;
        const updatedOrder = { ...ordersRef.current[orderIndex] };
        if (newParkingId) updatedOrder.ParkingId = newParkingId;
        else delete updatedOrder.ParkingId;
        dispatch(updateOrder(updatedOrder, solution.show, orderIndex));
        dispatch(setSolutionJson({ jsonTriggerVRP: true, jsonNoMapMovement: true }));
      });
    },
  );
}

export function attachInteractionEvents(
  marker,
  feature,
  dispatch,
  ordersRef,
  solution,
  onMarkerDragEnd,
  map,
) {
  marker.addEventListener('contextmenu', (evt) => {
    evt.stopPropagation();
    const featureId = feature.properties.id;
    const newOrders = ordersRef.current.filter((o) => o.InternalID !== featureId);
    dispatch(setOrders(newOrders, false, solution.show));
    dispatch(selectTourById({ noMapMovement: true }));
    dispatch(setSolutionJson({ jsonTriggerVRP: true, jsonNoMapMovement: true }));
  });

  marker.draggable = true;

  marker.addEventListener('dragstart', (evt) => {
    if (marker._removePopup) {
      marker._removePopup();
    }

    if (map._behavior) {
      map._behavior.disable();
    }

    const markerScreenPos = map.geoToScreen(evt.target.getGeometry());
    evt.target.offset = {
      x: evt.currentPointer.viewportX - markerScreenPos.x,
      y: evt.currentPointer.viewportY - markerScreenPos.y,
    };
    evt.stopPropagation();
  });

  marker.addEventListener('dragend', (evt) => {
    if (map._behavior) {
      map._behavior.enable();
    }
    evt.stopPropagation();
    onMarkerDragEnd(marker, feature);
  });

  marker.addEventListener('tap', (evt) => {
    evt.stopPropagation();
  });
}
